<template>
  <div class="goods_add">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-form-item label="菜单名称" prop="title">
        <el-input v-model="ruleForm.title"></el-input>
      </el-form-item>


        <el-form-item label="事件" prop="type">

            <el-select v-model="ruleForm.type" placeholder="请选择">
                <el-option
                        v-for="item in type"
                        :key="item"
                        :label="item"
                        :value="item">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="键值(key)" >
            <el-input v-model="ruleForm.key_str"></el-input>
        </el-form-item>
        <el-form-item label="跳转网址:" >
            <el-input v-model="ruleForm.url"></el-input>
        </el-form-item>
        <el-form-item label="上级菜单:" >

            <el-select v-model="ruleForm.pid" placeholder="请选择">
                <el-option
                        v-for="item in options"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                </el-option>
            </el-select>
        </el-form-item>
      <div class="mt-20"></div>

      <el-form-item class="quill-editor-top">
          <div  v-if="is_edit==false">

              <el-button
                      type="primary"
                      @click="submitForm('ruleForm',0)"


              >添加菜单</el-button
              >
              <el-button @click="resetForm('ruleForm')" ref="ruleForm">重置</el-button>
          </div>
        <div   v-else>

            <el-button
                    type="primary"
                    @click="submitForm('ruleForm',1)"


            >编辑</el-button
            >
            <el-button @click="cancel" ref="ruleForm">放弃</el-button>
        </div>



      </el-form-item>
    </el-form>
    <el-card>
        <p>
            <el-button
                    size="mini"
                    type="danger"
                    @click="create_menu(0)">生成自定义菜单</el-button>
            <el-button
                    size="mini"
                    type="primary"
                    @click="create_menu(1)">更新自定义菜单</el-button>
        </p>

        <el-row v-for="(item,index) in result_data" :key="index">

            <el-col>
                <el-row style="background-color:#f5fffa;border-bottom:1px solid #ccc; height: 50px;padding-top: 10px;padding-left: 10px">
                <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4">   {{item.name}}</el-col>
                <el-col :xs="5" :sm="5" :md="5" :lg="5" :xl="5">
                <span v-if="item.type==''">
                    --
                </span>
                    <span v-else>
                    {{ item.type }}
                    </span>
                </el-col>
                <el-col :xs="5" :sm="5" :md="5" :lg="5" :xl="5">
                    <span v-if="item.url==''">
                    --
                </span>
                    <span v-else>
                    {{ item.url }}
                    </span>
                  </el-col>

                    <el-col :xs="5" :sm="5" :md="5" :lg="5" :xl="5">
                        <span v-if="item.key==''">
                    --
                </span>
                        <span v-else>
                    {{ item.key }}
                    </span>
                    </el-col>
                <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4">
                    <el-button
                        size="mini"
                        @click="edit(item)">编辑</el-button>

                    <el-button
                            size="mini"
                            type="danger"
                            @click="delete_menu(item)">删除</el-button></el-col>
        </el-row>

                <el-row v-for="(item1,index1) in item.sub_button" :key="index1" style="padding-left:15px;height: 35px;padding-top: 10px" >

                    <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4"> {{ item1.name }}</el-col>
                    <el-col :xs="5" :sm="5" :md="5" :lg="5" :xl="5">
                        <span v-if="item1.type==''">
                    --
                </span>
                        <span v-else>
                    {{ item1.type }}
                    </span>
                    </el-col>
                    <el-col :xs="5" :sm="5" :md="5" :lg="5" :xl="5">
                        <span v-if="item1.url==''">
                    --
                </span>
                        <span v-else>
                    {{ item1.url }}
                    </span>
                      </el-col>
                    <el-col :xs="5" :sm="5" :md="5" :lg="5" :xl="5">
                        <span v-if="item1.key==''">
                    --
                </span>
                        <span v-else>
                    {{ item1.key }}
                    </span>
                    </el-col>
                    <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4">  <el-button
                            size="mini"
                            @click="edit(item1)">编辑</el-button>

                        <el-button
                                size="mini"
                                type="danger"
                                @click="delete_menu(item1)">删除</el-button></el-col>
                </el-row>

            </el-col>
        </el-row>







    </el-card>

  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  data() {
    return {
        type:["view","click"],
        options:[

        ],


      id: 0,
      menu:[],
      is_edit:false,
      result_data:[],
      ruleForm: {


        title: "",
        url:"",
        type:"",
        key_str:"",
        pid:"",
        art_id:""

      },
      dialogVisible: false,

      rules: {
        title: [
          {
            required: true,
            message: "请输入菜单名称",
            trigger: "blur",
          },
        ],


      },
    };
  },
  computed: {
    ...mapState({

        menu_data: (state) => state.wechat_menu.result,
    }),
  },
  methods: {
    ...mapActions({
        getWechatMenuIndexAction: "getWechatMenuIndexAction",
        addWechatMenuAction: "addWechatMenuAction",
        editWechatMenuAction:"editWechatMenuAction",
        deleteWechatMenuAction:"deleteWechatMenuAction",
        createWechatMenuAction:"createWechatMenuAction",
        updateWechatMenuAction:"updateWechatMenuAction"

    }),


      cancel(){
        this.is_edit=false
          this.id=""
          this.ruleForm.title=""
          this.ruleForm.type=""
          this.ruleForm.key_str=""
          this.ruleForm.pid=""

          this.ruleForm.url=""
      },
      edit(row) {

          this.id=row.id
        this.ruleForm.title=row.name
        this.ruleForm.type=row.type
        this.ruleForm.key_str=row.key
        if(row.pid>0){
            this.ruleForm.pid=row.pid
        }else{
            this.ruleForm.pid=""
        }

        this.ruleForm.url=row.url
        this.is_edit=true
      },


    saveData() {

        this.addWechatMenuAction({
            title:this.ruleForm.title,
            key_str:this.ruleForm.key_str,
            type:this.ruleForm.type,
            pid: this.ruleForm.pid?this.ruleForm.pid:0,
            url: this.ruleForm.url,
            art_id:this.ruleForm.art_id
        });

    },
    update(){
        this.editWechatMenuAction({
            id:this.id,
            title:this.ruleForm.title,

            key_str:this.ruleForm.key_str,
            type:this.ruleForm.type,
            pid: this.ruleForm.pid?this.ruleForm.pid:0,
            url: this.ruleForm.url,
            art_id:this.ruleForm.art_id
        });
    },
    submitForm(formName,type) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if(type==0){
              this.saveData();
          }
            if(type==1){
                this.update();
            }
        } else {
          this.$message("请输入正确信息");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    delete_menu(row){
      this.deleteWechatMenuAction({id:row.id})
    },
      create_menu(type){
        if(type==0){
          this.createWechatMenuAction({})
        }
          if(type==1){
             this.updateWechatMenuAction({})
          }
      },

    get_data(){
        this.getWechatMenuIndexAction({type:0});
        this.getWechatMenuIndexAction({type:1});
    },
  },
  created() {
   this.get_data()
  },
  watch: {

      menu_data(newdata, olddata) {

          if (newdata.code == 200) {

              this.options=newdata.data

          }
          if (newdata.code == 201) {

              this.result_data=newdata.data

          }
      if (newdata.code == 301) {

          this.$message({
              message: '菜单添加成功',
              type: 'success'
          });
          this.cancel()
          this.get_data()

      }
      if (newdata.code == 302) {

          this.$message({
              message: '菜单更新成功',
              type: 'success'
          });
        this.cancel()
        this.get_data()
      }
     if (newdata.code == 303) {

              this.$message({
                  message: '菜单删除成功',
                  type: 'success'
              });
              this.cancel()
              this.get_data()
          }
          if (newdata.code == 304) {

              this.$message({
                  message: '微信菜单添加成功',
                  type: 'success'
              });
              this.cancel()
              this.get_data()
          }
          if (newdata.code == 305) {

              this.$message({
                  message: '微信菜单更新成功',
                  type: 'success'
              });
              this.cancel()
              this.get_data()
          }
      // if (newdata.code == 303) {
      //   this.$message("类别删除成功");
      //   this.ruleForm.name = "";
      //   this.ruleForm.cate = "";
      //   this.id = 0;
      //
      //   this.getCategoryDataAction({});
      // }


      console.log(newdata, olddata);
    },
  },
};
</script>



<style>


.avatar-uploader .el-upload {
  border: 1px dashed #260a0a;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 80px;
  height: 80px;
  line-height: 80px;
  text-align: center;
}

.avatar {
  width: 80px;
  height: 80px;
  display: block;
}

.el-upload--picture-card {
  width: 80px !important;
  height: 80px !important;
  line-height: 90px !important;
}

.el-upload-list--picture-card .el-upload-list__item {
  width: 80px !important;
  height: 80px !important;
  line-height: 90px !important;
}

.title_bg {
  background-color: #f5fffa;
  padding: 10px;
}

.el-form-item__content {
  margin-left: 30px;

}
</style>
